import type { FC } from "react";

import { useSelector } from "react-redux";

import { IconButton } from "@similarweb/ui-components";

import HooksModalV5Key from "app/constants/HooksModalV5Key";
import { translate } from "app/filters/i18nFilter";
import { selectIsContactsDisabledByAccount } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";
import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";
import { openHooksModalV5 } from "app/services/ModalService";

import { StyledTopCompaniesContactDetailsOverlay } from "../containers/styles";
import useDummyLoading from "../hooks/useDummyLoading";

type Props<C extends IPlainObject = IPlainObject> = C & {
    isRevealed?: boolean;
};

function withDisabledByAccountOverlay<C extends IPlainObject = IPlainObject>(Component: FC<Props<C>>): FC<Props<C>> {
    return function WrappedWithApproveTermsGuard(props: Props<C>) {
        const [isDummyLoading, setIsDummyLoading] = useDummyLoading();

        const isContactsDisabledByAccount = useSelector(selectIsContactsDisabledByAccount);

        const handleUpgradeAccess = () => {
            setIsDummyLoading();
            openHooksModalV5(HooksModalV5Key.RevealContactsPayingUser);
        };

        if (isContactsDisabledByAccount && !props.isRevealed) {
            return (
                <StyledTopCompaniesContactDetailsOverlay>
                    <IconButton
                        type="flatTrial"
                        iconName="sparkles-gray"
                        iconSize="xs"
                        isLoading={isDummyLoading}
                        isDisabled={isDummyLoading}
                        onClick={handleUpgradeAccess}
                    >
                        {translate("si.common.upgrade")}
                    </IconButton>
                </StyledTopCompaniesContactDetailsOverlay>
            );
        }

        return <Component {...props} />;
    };
}

export default withDisabledByAccountOverlay;
